import { useBloomreachLinks } from './use-bloomreach-links.js';
import { useBloomreach } from '../context/context.js';
import { parseBloomreachImage } from '../utils/parse-bloomreach-image.js';
import { getContentByRef } from '../utils/get-content-by-ref.js';

const useBloomreachDeliveryInfo = ()=>{
    var ref, ref1, ref2;
    const { pageModel  } = useBloomreach();
    const ref3 = (ref = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page.models) === null || ref === void 0 ? void 0 : (ref1 = ref.deliveryInfo) === null || ref1 === void 0 ? void 0 : ref1.$ref;
    const content = getContentByRef(ref3, pageModel);
    const { deliveryItems =[] , description: description1 , link: brLink , linkHint , title: title1  } = content !== null && content !== void 0 ? content : {};
    const [link] = brLink ? useBloomreachLinks([
        brLink
    ]) : [];
    if (!(pageModel === null || pageModel === void 0 ? void 0 : (ref2 = pageModel.page) === null || ref2 === void 0 ? void 0 : ref2.models) || !content) {
        console.warn(`Cannot find main content for Delivery Info. Got: ${content} for $ref: ${ref3}`);
        return;
    }
    const items = deliveryItems.filter(({ title  })=>!!title
    ).map(({ description , id , image , price , title  })=>({
            description: description.value,
            id,
            image: parseBloomreachImage(image),
            price,
            title
        })
    );
    return {
        items,
        description: (description1 === null || description1 === void 0 ? void 0 : description1.value) || '',
        link,
        linkHint: linkHint || '',
        title: title1 || ''
    };
};

export { useBloomreachDeliveryInfo };
//# sourceMappingURL=use-bloomreach-delivery-info.js.map
